import { IconsConstants } from './../../../shared/common/icons-constants';
import { Component, OnInit, Injector, ViewChild, TemplateRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavComponent } from '../side-nav/components/side-nav/side-nav.component';
import { MatIconModule } from '@angular/material/icon';
import {
  AppBloc,
  AppBlocState,
  AuthenticatedUserDataReadyState,
  LoggedOutState,
  LogoutEvent,
} from 'src/app/shared/bloc/app-bloc';
import { debounceTime, of, takeUntil } from 'rxjs';
import { AuthUser } from 'src/app/core/data/model/auth-user-model';
import { TranslateModule } from '@ngx-translate/core';
import { NavBarService } from 'src/app/shared/services/nav-bar.service';
import { RoutesConstants } from 'src/app/shared/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { ImageIcon } from 'src/app/shared/interfaces';
import { ThemesService } from 'src/app/core/services/themes.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BaseConfirmationComponent } from 'src/app/shared/component/base-confirmation-component/base-confirmation-component';
import { ModalPopupComponent } from 'src/app/shared/component/modal-popup/modal-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationCallerCallBack } from 'src/app/shared/bloc/confiramtion-modal-bloc';

@Component({
  selector: 'app-side-nav-bar',
  standalone: true,
  imports: [
    CommonModule, 
    TranslateModule,
    MatIconModule, 
    SideNavComponent,
    MatExpansionModule,
    ModalPopupComponent
  ],
  templateUrl: './side-nav-bar.component.html',
  styleUrls: ['./side-nav-bar.component.scss'],
  providers: []
})
export class SideNavBarComponent extends BaseConfirmationComponent implements OnInit {
  user!: AuthUser;
  logo: ImageIcon;
  expandLogo: boolean;
  isSmallScreen: boolean;
  hoverEnabled$ = this.navBarService.isCollapsed$.pipe(debounceTime(100), takeUntil(this.destroy$));
  @Input() isEmptySideBar: boolean = false;
  @ViewChild('logoutPopup', { static: true }) logoutPopupComponent: TemplateRef<any>;

  get isSideNavCollapsed(): boolean {
    return this.navBarService.isSideNavCollapsed;
  }

  IconsConstants = IconsConstants;
  constructor(
    injector: Injector, 
    private appBloc: AppBloc, 
    private breakPointObserver: BreakpointObserver,
    private navBarService: NavBarService,
    private dialog: MatDialog
  ) {
    super(['SUCCESS_MESSAGES'], injector, true);
    this.listenToAppBlocState();
  }

  ngOnInit(): void {
    this.onHandleLogoChange();
    this.listenToScreenSizeChange();
  }

  // publics
  onCollapseToggleSideNav(): void {
    this.injector.get(NavBarService).toggleSideNavBar();
  }

  onLogout(): void {
    this.onOpenConfirmation(
      this.dialog,
      this.logoutPopupComponent,
      this.onHandleLogoutAction(),
      () => of(null),
      this.translationsList['SUCCESS_MESSAGES']['CONFIRMATION'],
      this.translationsList['SUCCESS_MESSAGES']['DO_YOU_WANT_TO_TAKE_ACTION']
    )
    
  }

  navigateToHomePage(): void {
    this.navigateToRoute(RoutesConstants.DASHBOARD_PAGE_URL);
  }

  navigateToUserProfile(event: Event): void {
    event.stopPropagation();
    this.navigateToRoute(RoutesConstants.USER_PROFILE_PAGE_URL);
    if(!this.navBarService.isSideNavCollapsed && this.isSmallScreen) {
      this.navBarService.closeSideNavBar();
    }
  }

  private listenToAppBlocState(): void {
    this.appBloc.onState.pipe(takeUntil(this.destroy$)).subscribe((state) => this.onHandleAppBLocState(state));
  }
  private onHandleAppBLocState(state: AppBlocState): void {
    if (state instanceof AuthenticatedUserDataReadyState) {
      this.user = state.user;
    } else if (state instanceof LoggedOutState) {
      this.navigateToRoute('/' + RoutesConstants.LOGIN_PAGE_URL);
    }
  }

  private onHandleLogoChange(): void {
    this.injector
      .get(ThemesService)
      .changeLogo$
      .pipe(takeUntil(this.destroy$))
      .subscribe(themeLogo => {
        this.expandLogo = themeLogo.isExpanded;
        this.logo = themeLogo;
      })
  }

  private onHandleLogoutAction(): ConfirmationCallerCallBack<void> {
    return () => of(this.appBloc.setEvent.next(new LogoutEvent()));
  }

  private listenToScreenSizeChange(): void {
    this.breakPointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.destroy$))
      .subscribe(res => this.isSmallScreen = res.matches);
  }
}
